export const locale = {
  HEADING_NAME: "陳　ペリー",
  HEADING_TITLE: ", DPsych",
  SUBHEADING: "心理相談・ユング箱庭・Social Dreaming - イギリス、香港、他の国",
  TAB1: "自己紹介",
  TAB2: "療法",
  TAB3: "相談の案内",
  TAB4: "Memories",
  TAB5: "social dreaming",
  WELCOMETITLE: "ようこそ",
  PROPIC: "マレーシアで働いていたとき",
  WELCOME: "Hi, you can call me Perry. I'm based in Edinburgh, Scotland. I provide in-person/online counselling & psychotherapy in English, Cantonese or Mandarin mainly for clients based in the UK and HK. I'm also a counselling tutor and a researcher (writing up my doctoral thesis at the moment) at the University of Edinburgh, as well as a Social Dreaming host in training."

}